import palettes from '@thehotelsnetwork/color-palettes';

const baseUrl = import.meta.env.VUE_APP_API_URL;
const mercureUrl = import.meta.env.VUE_APP_MERCURE_URL;

const apiURL = {
  base: baseUrl,
  mercure: mercureUrl,
};

const languages = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italiano' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'es', label: 'Español' },
  { value: 'sv', label: 'Svenska' },
  { value: 'ja', label: '日本語' },
  { value: 'th', label: ' ภาษาไทย' },
];

const corporateWebLangs = ['en', 'es', 'de', 'fr', 'it', 'pt'];

const adminAccountTypes = ['account_owner', 'account_admin', 'admin'];

const defaultColors = {
  brand: palettes?.brand?.primary['500'] || '#0378CD',
  cluster: palettes?.charts?.amethyst['500'] || '#844FFF',
};

const authConfig = {
  domain: import.meta.env.VUE_APP_AUTH_DOMAIN || 'thehotelsnetwork.eu.auth0.com',
  clientId: import.meta.env.VUE_APP_AUTH_CLIENT_ID || 'n8DqKiVg2XtNOdysyNdVGGq91UhNNkzI',
};

const thnAppsUrl = {
  latte: import.meta.env.VUE_APP_LATTE_URL,
  admin: import.meta.env.VUE_APP_ADMIN_URL,
  benchdirect: import.meta.env.VUE_APP_BDIRECT_URL,
  dashboards: import.meta.env.VUE_APP_DASHBOARDS_URL,
  personalization: import.meta.env.VUE_APP_PERSONALIZATION_URL,
  demand: import.meta.env.VUE_APP_DEMAND_URL,
  agenticai: import.meta.env.VUE_APP_AGENTIC_AI_URL,
};

export {
  apiURL,
  languages,
  authConfig,
  thnAppsUrl,
  defaultColors,
  adminAccountTypes,
  corporateWebLangs,
};
